import React, { useContext, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Formik, FormikActions } from "formik";
import { useMutation } from "@apollo/client";
import { Hidden } from "@material-ui/core";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import qs from "qs";

import Form from "./Form";
import { DispatchContext } from "App";
import { LoginFormValues, User } from "models/user";
import { DuoLogin } from "graphql/user/user.gql";
import { isLogin } from "utils/auth";
import {
  StyledMainGrid,
  StyledLeftGrid,
  StyledRightGrid,
  Title,
  LoginCallout,
  StyledForm
} from "./styled";
import DashboardHeader from "assets/login-dashboard-header.svg";
import { StyledGrid } from "components/simple";

const initialFormValues = {
  email: "",
  password: "",
  loginFromAdmin: false
};

const LoginForm: React.FC = () => {
  const [duoLogin] = useMutation(DuoLogin);
  const history = useHistory();
  const { dispatch } = useContext(DispatchContext);

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email"),
    password: Yup.string()
  });

  const queryParams = qs.parse(location.search, {
    ignoreQueryPrefix: true
  });

  const expired = queryParams["expired"];

  useEffect(() => {
    if (expired) {
      dispatch({
        type: "error",
        title: "Your session has timed out",
        description: "Log in to continue"
      });
      history.push("/login");
    }
  }, [expired]);

  if (isLogin()) {
    return <Redirect push from="" to="/assessments" />;
  }

  async function submitForm(
    values: LoginFormValues,
    actions: FormikActions<LoginFormValues>
  ): Promise<User | null> {
    try {
      const duoLoginResponse = await duoLogin({ variables: { input: values } });
      if (duoLoginResponse?.data && duoLoginResponse.data?.duoLogin) {
        const duoUrl = duoLoginResponse.data.duoLogin.duoUrl;
        // redirect to duoUrl
        window.location.href = duoUrl;
      }
    } catch (error) {
      if (error?.graphQLErrors[0]?.extensions?.code === "REQUIRE_RESET_PASSWORD") {
        dispatch({
          type: "error",
          title: "Your password has expired",
          description: "Please reset your password"
        });
        history.push("/forgot_password");
      } else if (error?.graphQLErrors[0]?.message === "Admin account deactivated") {
        dispatch({
          type: "error",
          title: "Account deactivated",
          description: "Your admin account has been deactivated, please contact support"
        });
      } else {
        dispatch({ type: "error", description: "Check email and password" });
        return null;
      }
    } finally {
      actions.setSubmitting(false);
    }
    return null;
  }

  return (
    <>
      <StyledMainGrid container spacing={0}>
        <Hidden mdDown>
          <StyledLeftGrid item lg={6}></StyledLeftGrid>
        </Hidden>
        <StyledRightGrid item lg={6} xs={12} style={{ maxWidth: "100%" }}>
          <StyledGrid
            backgroundImage={DashboardHeader}
            height={"200px"}
            item
            width="100%"
            backgroundRepeat="no-repeat"
            backgroundPosition="center"
          />
          <StyledForm>
            <Title>Sign In</Title>
            <LoginCallout>Sign into your Admin Dashboard</LoginCallout>
            <Formik
              render={props => <Form {...props} />}
              initialValues={initialFormValues}
              onSubmit={submitForm}
              validationSchema={LoginSchema}
              validateOnBlur
            />
          </StyledForm>
        </StyledRightGrid>
      </StyledMainGrid>
    </>
  );
};

export default LoginForm;
